import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import CheckIn from "@/pages/CheckIn";
import CheckOut from "@/pages/CheckOut";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/in" element={<CheckIn />} />
          <Route path="/out" element={<CheckOut />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
